/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react"; 
import { Tabs, TabsContent, TabsList, TabsTrigger, } from "@/components/ui/tabs"
import  Primitive from "./primative"
import FontColor from "./fontcolor";
import  BasicBlocks from './basicblocks'
import BlogItem from "./blogitem";
import AdvancedBlocks from "./advancedblocks";
type Props = {
  id?: string;
};

const Tailwind: React.FC<Props> = (props): JSX.Element => {
  return (
    <div id="design-elements" className="h-screen w-full overflow-auto bg-harvey-black flex flex-col items-center">
      <div className="mt-8 w-11/12">
        <Tabs defaultValue="types" className="w-full">
          <TabsList className="grid w-full grid-cols-6 bg-gray-600 rounded ">
            <TabsTrigger value="types">Typography and Colours</TabsTrigger>
            <TabsTrigger value="primative">Primative Elements</TabsTrigger>
            <TabsTrigger value="basic-blocks">Basic Blocks</TabsTrigger>
            <TabsTrigger value="advanced-blocks">Sliders</TabsTrigger>
            <TabsTrigger value="blogs">Blogs</TabsTrigger>
            <TabsTrigger value="extras">Extras</TabsTrigger>
          </TabsList>

          <TabsContent value="types" className="p-8 w-10/12">
            <FontColor/>
          </TabsContent>

          <TabsContent value="primative" className="p-8 w-10/12">
            <Primitive/>
          </TabsContent>

          <TabsContent value="basic-blocks" className="p-8 w-10/12">
              <BasicBlocks/>
          </TabsContent>

          <TabsContent value="advanced-blocks" className="p-8 w-10/12">
              <AdvancedBlocks/>
          </TabsContent>

          <TabsContent value="blogs" className="p-8 w-10/12">
              <BlogItem/>
          </TabsContent>

        </Tabs>
      </div>
    </div>

  );
};

export default Tailwind;
